//配置全局访问接口地址
// 正式
let commonUrl = "https://api.binvestxpay.com";
// 测试
// let commonUrl = "https://new-lc.77537873626.bond/"
// test654@gmail.com"

let baseUrl = {
    commonUrl
}
 
export default baseUrl